import React from "react";
import LearningPlanExamResults from "./LearningPlanExamResults";

export default class LearningPlanExamSuccessPreTest extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log("LearningPlanExamSuccessPreTest", this.props);
    const { is_admin = false } = this.props;
    const knowledge = this.getResultItem("KNOWLEDGE");
    const { score } = knowledge;
    const { raw: correct, rawMax: total } = score;
    return (
      <div className="learning-plan-exam-success with-results">
        <div className="bordered-heading">
          <h1>
            {I18n.t("pretest")}: {this.props.course.name}
          </h1>
        </div>
        <h2 style={{ marginTop: 0, marginBottom: "1rem" }}>
          {I18n.t("score_blank_out_of_blank", {
            correct: correct,
            total: total,
          })}
        </h2>
        <LearningPlanExamResults {...this.props} />
        {!is_admin ? (
          <p style={{ paddingBottom: "1rem" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              className="btn"
            >
              {I18n.t("continue_learning")}
            </a>
          </p>
        ) : null}
      </div>
    );
  }

  getResultItem(name) {
    const { results = [] } = this.props;
    return results.find((result) => result.type === name);
  }
}
